export const events = {
  goToTeamChart: 'Go to team chart',
  editTeamChart: 'Edit team chart',
  createNewTeamSubmitFromChart: 'Create new team submit from chart',
  addExistingTeamFromChart: 'Add existing team from chart',
  updateTeamFromChart: 'Update team from chart',
  goToTeamChartFilterResult: 'Go to team chart filter result',
  goToTeamSidepanel: 'Go to team sidepanel',
  goToTeamChartDisplayDropdown: 'Go to team chart display dropdown',
}
